import { AppleAuthClientId } from 'mewe/constants';
import config from 'mewe/config';

export class AppleAuth {
  static isInitialized = false;
  static initializationPromise = null;
  static isQA = window.location.hostname.includes('qa-groupl.es');

  static clientId = this.isQA ? AppleAuthClientId.QA : (config.environment === 'prod' ? AppleAuthClientId.PROD : AppleAuthClientId.DEV);

  static loadAppleSDK() {
    if (document.getElementById('appleid-sdk')) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.id = 'appleid-sdk';
      script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  static async initialize() {
    if (this.isInitialized) return;
    if (this.initializationPromise) return this.initializationPromise;
    this.initializationPromise = this.loadAppleSDK().then(() => {
      this.isInitialized = true;
    });
    return this.initializationPromise;
  }

  static initializeAppleSignIn(onSuccess, onError) {
    try {
      window.AppleID.auth.init({
        clientId: this.clientId,
        scope: 'name email',
        redirectURI: window.location.origin + '/auth/apple/callback',
        usePopup: true,
      });
      window.AppleID.auth.signIn().then(onSuccess).catch(onError);
    } catch (e) {
      onError(e);
    }
  }
}

export default AppleAuth;